(function (root, factory) {
  'use strict';
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.C1Delivery = api;
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  // Customer details stay in this page's memory only. This module deliberately
  // does not write to cookies, localStorage, sessionStorage, or analytics.
  var defaults = {
    title: 'Delivery details',
    introduction: 'Add your address to see shipping and your total.',
    firstName: 'First name', lastName: 'Last name', email: 'Email', emailHint: 'For your order receipt.',
    phone: 'Mobile number', phoneHint: 'Use a Philippine mobile number the rider can reach.',
    province: 'Province', city: 'City / Municipality', barangay: 'Barangay',
    chooseProvince: 'Select province', chooseCity: 'Select city / municipality',
    chooseBarangay: 'Select barangay',
    streetAddress: 'House, street and subdivision',
    streetPlaceholder: 'House or unit number, street, subdivision',
    landmark: 'Landmark (optional)', landmarkPlaceholder: 'Nearby place to help the rider',
    zip: 'ZIP code', zipHint: 'Check your 4-digit ZIP code. You can edit it.',
    zipSuggested: 'Suggested ZIP code — please check it. You can edit it.',
    close: 'Close', back: 'Back to cart', continue: 'Continue to payment',
    loading: 'Loading delivery locations…', retry: 'Try again',
    loadError: 'We couldn’t load the delivery locations. Please try again.',
    checkoutError: 'We couldn’t open checkout. Your details are still here. Please try again.',
    checkoutRefreshed: 'Your checkout has been refreshed. Check the total, then continue to payment.',
    checkoutExistingChanged: 'Your earlier checkout uses different details.',
    checkoutHeld: 'Your earlier payment is being checked. Keep its payment page open and contact us before trying again.',
    paymentCheckTitle: 'Please check your earlier payment',
    paymentCheckHint: 'We couldn’t safely reopen the earlier payment page. Check its payment or COD status with us before starting another checkout.',
    backToDelivery: 'Back to delivery details', contactUs: 'Contact us',
    continuing: 'Opening payment…', openingPaymentHint: 'Please wait while we open your payment page.',
    openPaymentPage: 'Open payment page', paymentFallbackHint: 'If the payment page hasn’t opened, use the link below.', required: 'Please fill in this field.',
    invalidEmail: 'Enter a valid email address.',
    invalidPhone: 'Enter a valid Philippine mobile number, for example 09171234567.',
    invalidLocation: 'Choose a location from the list.',
    invalidZip: 'Enter a 4-digit ZIP code.',
    tooLong: 'Please shorten this field.',
    country: 'Philippines', shipping: 'Shipping', total: 'Total', items: 'Items', taxIncluded: 'Tax included', tax: 'Tax', discount: 'Discount',
    quotePrompt: 'Complete your address to see the total.', quoteLoading: 'Getting shipping and total…',
    quoteNeeds: 'To see the total, complete: {fields}.', quoteMore: '+{count} more',
    quoteError: 'Couldn’t get shipping. Please try again.', addLandmark: 'Add landmark (optional)',
    shopifyFallback: 'Delivery checkout isn’t available right now. Your cart is still here. Continuing to checkout.',
    shopifyFallbackSlow: 'This is taking longer than usual. Your cart is still here.',
    shopifyFallbackAction: 'Continue to checkout',
    manilaDistrict: '{name} (Manila)', editSummary: 'Edit',
    rushShort: 'Need it today? Rush via Lalamove for Metro Manila/Luzon.',
    paymentNext: 'Next: choose COD, GCash, QR Ph or card.', messengerHelp: 'Questions? Message us on Messenger',
    requestRush: 'I need rush delivery', rushHint: 'For Luzon / Metro Manila, 9am–5pm; Chibi orders until 2pm. Add and confirm a pin to check Lalamove availability. J&T Express stays selected until you choose another option. Availability does not guarantee same-day delivery.',
    pinLabel: 'Google Maps pin link or coordinates', pinPlaceholder: '14.450000, 120.980000',
    pinHint: 'Paste a full Google Maps pin link or latitude, longitude. Your address above is still required.',
    pinConfirm: 'This pin matches my delivery address', pinConfirmed: 'Delivery pin confirmed.',
    pinReady: 'Check these coordinates, then confirm the pin below.',
    pinInvalid: 'Use a Philippines pin from a full Google Maps link or coordinates such as 14.450000, 120.980000. J&T Express is still available.',
    pinViewport: 'This link shows a map view, not an exact pin. Copy the place pin link or enter its latitude, longitude.',
    pinShortLink: 'Short Maps links cannot be checked here. Open the link, then copy the full pin link or enter its latitude, longitude.',
    pinLocation: 'Use my current location', pinLocating: 'Getting your location…',
    pinLocationError: 'Couldn’t get your location. Paste a full Google Maps pin link or coordinates instead.',
    pinSearch: 'Find my address in Google Maps', fare: 'Lalamove fare', rushFee: 'Rush fee',
    resumingDelivery: 'Showing your earlier delivery choice. Continue to resume that payment page.',
    cartSaving: 'Saving your item… You can fill in your delivery details now.',
    cartSaveError: 'We couldn’t confirm your saved item. Refresh this page and check your cart before continuing.'
  };
  var config, words, directoryPromise, directory, zipMap, directoryURL;
  var checkoutHandler, view, savedValues, pending, resolvePending;
  var currentOptions = {}, previousFocus, submitting = false, departing = false, paymentHeld = false;
  var paymentFallbackTimer, verifiedPaymentURL;
  // Shown while delivery checkout is slow, then used to leave for shop checkout.
  var SHOPIFY_FALLBACK_WAIT_MS = 8000;
  var shopifyFallbackStarted = false, shopifyFallbackTimer = null;
  var cartReadyPending = false, cartReadyFailed = false;
  var currentQuote, quoteKey, currentPricingKey, scheduledQuoteKey, quoteBindingPending = false, quoteVersion = 0, quoteTimer, quoteExpiryTimer, quoteRequest, quoting = false;
  var postalWasSuggested = false;
  var provincePromises = Object.create(null), locationVersion = 0, lifecycleVersion = 0, retryAction;
  var pinLocationVersion = 0;
  // Generated from approved carrier zones luzon / metro-manila in rush-provinces.json.
  var rushProvinces = ['ABRA', 'ALBAY', 'APAYAO', 'AURORA', 'BATAAN', 'BATANES', 'BATANGAS', 'BENGUET', 'BULACAN', 'CAGAYAN', 'CAMARINES-NORTE', 'CAMARINES-SUR', 'CATANDUANES', 'CAVITE', 'IFUGAO', 'ILOCOS-NORTE', 'ILOCOS-SUR', 'ISABELA', 'KALINGA', 'LA-UNION', 'LAGUNA', 'MARINDUQUE', 'MASBATE', 'METRO-MANILA', 'MOUNTAIN-PROVINCE', 'NUEVA-ECIJA', 'NUEVA-VIZCAYA', 'OCCIDENTAL-MINDORO', 'ORIENTAL-MINDORO', 'PAMPANGA', 'PANGASINAN', 'QUEZON', 'QUIRINO', 'RIZAL', 'ROMBLON', 'SORSOGON', 'TARLAC', 'ZAMBALES'];
  // City of Manila districts as the live J&T directory lists them under METRO-MANILA
  // (numbered Manila barangays). Display label only; San Juan and North Caloocan are other cities.
  var manilaDistricts = ['BINONDO', 'ERMITA', 'INTRAMUROS', 'MALATE', 'PACO', 'PANDACAN', 'PORT AREA', 'QUIAPO', 'SAMPALOC',
    'SAN MIGUEL', 'SAN NICOLAS', 'SANTA ANA', 'SANTA CRUZ', 'STA CRUZ SOUTH', 'SANTA MESA', 'TONDO I II', 'TONDO NORTH'];
  var messengerURL = 'https://m.me/carryone.creations';

  function clean(value) { return typeof value === 'string' ? value.trim() : ''; }

  function normalizeDropoffPin(value) {
    if (!value || typeof value.lat !== 'number' || typeof value.lng !== 'number' ||
        !Number.isFinite(value.lat) || !Number.isFinite(value.lng) ||
        value.lat < 5 || value.lat > 21.5 || value.lng < 116 || value.lng > 127) return null;
    return { lat: value.lat, lng: value.lng };
  }

  function coordinatePair(value) {
    var match = clean(value).match(/^([+-]?(?:\d+(?:\.\d+)?|\.\d+))\s*,\s*([+-]?(?:\d+(?:\.\d+)?|\.\d+))$/);
    return match ? normalizeDropoffPin({ lat: Number(match[1]), lng: Number(match[2]) }) : null;
  }

  // Never follow redirects or treat /@ map camera coordinates as a delivery pin.
  function parsePinInput(value) {
    var source = clean(value), pin = coordinatePair(source);
    if (!source) return { pin: null, error: null };
    if (pin) return { pin: pin, error: null };
    var url;
    try { url = new URL(source); } catch (_) { return { pin: null, error: 'pinInvalid' }; }
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return { pin: null, error: 'pinInvalid' };
    if (['maps.app.goo.gl', 'goo.gl'].includes(url.hostname)) return { pin: null, error: 'pinShortLink' };
    var host = url.hostname.toLowerCase();
    if (!['google.com', 'www.google.com', 'maps.google.com', 'google.com.ph', 'www.google.com.ph', 'maps.google.com.ph'].includes(host) ||
        (!host.startsWith('maps.') && !/^\/maps(?:\/|$)/.test(url.pathname))) return { pin: null, error: 'pinInvalid' };
    var path;
    try { path = decodeURIComponent(url.pathname); } catch (_) { return { pin: null, error: 'pinInvalid' }; }
    var found = [], match, pattern = /!3d([+-]?(?:\d+(?:\.\d+)?|\.\d+))!4d([+-]?(?:\d+(?:\.\d+)?|\.\d+))(?=!|\/|$)/g;
    while ((match = pattern.exec(path))) {
      var target = normalizeDropoffPin({ lat: Number(match[1]), lng: Number(match[2]) });
      if (!target) return { pin: null, error: 'pinInvalid' };
      if (!found.some(function (entry) { return entry.lat === target.lat && entry.lng === target.lng; })) found.push(target);
    }
    if (found.length > 1) return { pin: null, error: 'pinInvalid' };
    if (found.length === 1) return { pin: found[0], error: null };
    var queries = url.searchParams.getAll('q').concat(url.searchParams.getAll('query'));
    if (queries.length) {
      var pins = queries.map(coordinatePair);
      if (pins.every(function (entry) { return entry && entry.lat === pins[0].lat && entry.lng === pins[0].lng; })) return { pin: pins[0], error: null };
    }
    return { pin: null, error: /\/@/.test(path) ? 'pinViewport' : 'pinInvalid' };
  }

  function isRushProvince(name) {
    var key = normalizePlace(name).replace(/ /g, '-');
    return rushProvinces.includes(key);
  }

  function standardRate(quote) {
    var rates = quote && quote.rates || [];
    // A server-reconciled earlier invoice resumes an explicit prior choice.
    if (quote && quote.recoverable === true && rates.length === 1) return rates[0];
    var candidates = rates.filter(function (rate) { return rate.title === 'J&T Express'; });
    return candidates.find(function (rate) { return rate.id === quote.defaultRateId; }) || candidates[0] || null;
  }

  function normalizePhone(value) {
    var source = clean(value);
    if (!source || !/^\+?[\d\s().-]+$/.test(source)) return null;
    var digits = source.replace(/\D/g, '');
    if (/^09\d{9}$/.test(digits)) return '+63' + digits.slice(1);
    if (/^639\d{9}$/.test(digits)) return '+' + digits;
    if (/^9\d{9}$/.test(digits)) return '+63' + digits;
    return null;
  }

  function selectedId(values, key) {
    var value = values && (values[key + 'Id'] || values[key]);
    return typeof value === 'string' ? value : value && value.id;
  }

  function validateSelection(data, values) {
    var provinces = data && Array.isArray(data.provinces) ? data.provinces : [];
    var province = provinces.find(function (item) { return item.id === selectedId(values, 'province'); });
    var city = province && (province.cities || []).find(function (item) { return item.id === selectedId(values, 'city'); });
    var barangay = city && (city.barangays || []).find(function (item) { return item.id === selectedId(values, 'barangay'); });
    return province && city && barangay ? { province: province, city: city, barangay: barangay } : null;
  }

  function invalid(field, code) {
    var error = new Error(code);
    error.field = field;
    error.code = code;
    throw error;
  }

  function normalizeAddress(values, data) {
    values = values || {};
    var result = {};
    ['firstName', 'lastName', 'email', 'streetAddress', 'landmark', 'zip'].forEach(function (field) {
      result[field] = clean(values[field]);
    });
    ['firstName', 'lastName', 'email', 'streetAddress', 'zip'].forEach(function (field) {
      if (!result[field]) invalid(field, 'required');
    });
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(result.email)) invalid('email', 'invalidEmail');
    result.phone = normalizePhone(values.phone);
    if (!result.phone) invalid('phone', 'invalidPhone');
    ['firstName', 'lastName'].forEach(function (field) {
      if (result[field].length > 100) invalid(field, 'tooLong');
    });
    if (result.email.length > 254) invalid('email', 'tooLong');
    if (result.streetAddress.length > 200) invalid('streetAddress', 'tooLong');
    if (result.landmark.length > 100) invalid('landmark', 'tooLong');
    if (!/^\d{4}$/.test(result.zip)) invalid('zip', 'invalidZip');
    var selection = validateSelection(data, values);
    if (!selection) {
      var province = data && (data.provinces || []).find(function (item) { return item.id === selectedId(values, 'province'); });
      var city = province && (province.cities || []).find(function (item) { return item.id === selectedId(values, 'city'); });
      invalid(!province ? 'province' : !city ? 'city' : 'barangay', 'invalidLocation');
    }
    ['province', 'city', 'barangay'].forEach(function (field) {
      result[field] = { id: selection[field].id, name: selection[field].name };
    });
    result.directoryVersion = data && data.source && data.source.version || '';
    // A blank optional landmark is excluded from the delivery payload, so it
    // cannot produce a trailing label or punctuation in an address line.
    if (!result.landmark) delete result.landmark;
    if (values.requestRush === true && isRushProvince(result.province.name)) {
      result.requestRush = true;
      var pin = normalizeDropoffPin(values.dropoffPin);
      if (pin && values.dropoffPin.confirmed === true) result.dropoffPin = { lat: pin.lat, lng: pin.lng, confirmed: true };
    }
    return result;
  }

  // One field at a time, the same rules and message codes as normalizeAddress.
  function fieldProblem(key, value) {
    value = clean(value);
    if (key === 'phone') return normalizePhone(value) ? '' : 'invalidPhone';
    if (!value) return 'required';
    if (key === 'email') return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? 'invalidEmail' : value.length > 254 ? 'tooLong' : '';
    if (key === 'zip') return /^\d{4}$/.test(value) ? '' : 'invalidZip';
    return '';
  }

  function normalizePlace(value) {
    return clean(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }

  function localCityName(city, province) {
    var cityName = normalizePlace(city), provinceName = normalizePlace(province);
    var local = provinceName && cityName.indexOf(provinceName + ' ') === 0 ? cityName.slice(provinceName.length + 1) : cityName;
    // CEBU-CITY in CEBU stays 'CEBU CITY', never a bare 'CITY'.
    return local === 'CITY' ? cityName : local;
  }

  function comparablePlace(value) {
    return normalizePlace(value).replace(/^CITY OF /, '').replace(/ CITY$/, '');
  }

  // ZIP data is a separately sourced optional suggestion table, not part of the
  // J&T directory. Multiple valid candidates intentionally remain ambiguous.
  function postalSuggestions(map, selection) {
    if (!map || !selection || !selection.province || !selection.city) return [];
    var candidates = [], province = selection.province, city = selection.city, barangay = selection.barangay;
    function add(value) {
      if (Array.isArray(value)) return value.forEach(add);
      if (value && typeof value === 'object') return add(value.zip || value.zipCode || value.postalCode);
      var candidate = typeof value === 'number' ? String(value) : clean(value);
      if (/^\d{4}$/.test(candidate) && candidates.indexOf(candidate) === -1) candidates.push(candidate);
    }
    var byId = map.byId || map;
    if (barangay && Object.prototype.hasOwnProperty.call(byId, barangay.id)) add(byId[barangay.id]);
    else if (Object.prototype.hasOwnProperty.call(byId, city.id)) add(byId[city.id]);
    var entries = Array.isArray(map) ? map : map.entries || [];
    var matched = entries.filter(function (entry) {
      var sameProvince = entry.provinceId ? entry.provinceId === province.id : comparablePlace(entry.province) === comparablePlace(province.name);
      if (!sameProvince) return false;
      var sameCity = entry.cityId ? entry.cityId === city.id : comparablePlace(localCityName(entry.city, entry.province)) === comparablePlace(localCityName(city.name, province.name));
      if (!sameCity) return false;
      if (entry.barangayId) return !!barangay && entry.barangayId === barangay.id;
      if (entry.barangay) return !!barangay && comparablePlace(entry.barangay) === comparablePlace(barangay.name);
      return true;
    });
    // Prefer a barangay-specific row if the source provides one.
    var specific = matched.filter(function (entry) { return entry.barangayId || entry.barangay; });
    (specific.length ? specific : matched).forEach(function (entry) { add(entry.zip || entry.zipCode || entry.postalCode); });
    return candidates.sort();
  }

  function readConfig() {
    if (config) return config;
    var element = root.document && root.document.getElementById('c1-delivery-config');
    try { config = element ? JSON.parse(element.textContent) : {}; }
    catch (error) { config = {}; }
    words = Object.assign({}, defaults, config.i18n || {});
    return config;
  }

  function fetchJSON(url) {
    return root.fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('delivery_data_unavailable');
      return response.json();
    });
  }

  function loadData() {
    readConfig();
    if (!directoryPromise) {
      directoryURL = config.directoryUrl || config.dictionaryUrl || config.directoryURL;
      // ZIP suggestions are optional. Fetch them alongside the required
      // directory without delaying the form or overwriting a manually typed ZIP.
      var zipURL = config.zipMapUrl || config.zipMapURL;
      if (zipURL) fetchJSON(zipURL).then(function (map) {
        zipMap = map;
        if (view && pending && directory) {
          var previousZIP = view.fields.zip.value;
          suggestZIP();
          if (view.fields.zip.value !== previousZIP) scheduleQuote();
        }
      }, function () { zipMap = null; });
      directoryPromise = (directoryURL ? fetchJSON(directoryURL) : Promise.reject(new Error('missing_delivery_directory')))
        .then(function (data) {
          if (!data || !Array.isArray(data.provinces) || !data.provinces.length) throw new Error('invalid_delivery_directory');
          directory = data;
        }).then(function () { return directory; }, function (error) {
          directoryPromise = null;
          throw error;
        });
    }
    return directoryPromise;
  }

  function loadProvince(id) {
    var province = directory.provinces.find(function (item) { return item.id === id; });
    if (!province) return Promise.reject(new Error('invalid_delivery_province'));
    if (Array.isArray(province.cities)) return Promise.resolve(province);
    if (!provincePromises[id]) {
      var base = new URL(directoryURL, root.location.href);
      var url = province.childrenUrl || (config.provinceUrls && config.provinceUrls[id]);
      provincePromises[id] = (url ? fetchJSON(new URL(url, base).href) : Promise.reject(new Error('missing_delivery_province')))
        .then(function (data) {
          if (!data || data.id !== id || !Array.isArray(data.cities)) throw new Error('invalid_delivery_province');
          province.cities = data.cities;
          return province;
        }).catch(function (error) {
          delete provincePromises[id];
          throw error;
        });
    }
    return provincePromises[id];
  }

  function element(tag, className, text) {
    var node = root.document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function readableName(name) {
    return clean(name).replace(/-/g, ' ').toLowerCase().replace(/(^|\s)\S/g, function (letter) { return letter.toUpperCase(); });
  }

  function locationName(item, kind) {
    var value = item.name;
    if (kind === 'city') {
      var province = directory.provinces.find(function (entry) { return entry.id === view.fields.province.value; });
      value = localCityName(value, province && province.name);
      if (province && normalizePlace(province.name) === 'METRO MANILA' && manilaDistricts.includes(value)) {
        return words.manilaDistrict.replace('{name}', readableName(value));
      }
    }
    return readableName(value);
  }

  function fillSelect(field, items, placeholder, kind, selectedValue) {
    field.replaceChildren();
    var empty = element('option', '', placeholder);
    empty.value = '';
    field.append(empty);
    var ordered = (items || []).slice();
    if (kind === 'province') ordered.sort(function (a, b) {
      return Number(normalizePlace(b.name) === 'METRO MANILA') - Number(normalizePlace(a.name) === 'METRO MANILA');
    });
    var labels = new Map(ordered.map(function (item) { return [item, locationName(item, kind)]; }));
    // Towns and barangays: A–Z by the label the buyer sees, with numbers in order.
    if (kind !== 'province') {
      var collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });
      ordered.sort(function (a, b) { return collator.compare(labels.get(a), labels.get(b)); });
    }
    ordered.forEach(function (item) {
      var option = element('option', '', labels.get(item));
      option.value = item.id;
      field.append(option);
    });
    field.value = selectedValue || '';
    field.disabled = submitting || !items || !items.length;
  }

  function getValues() {
    var values = {};
    Object.keys(view.fields).forEach(function (key) { values[key] = view.fields[key].value; });
    if (!view.rush.hidden && view.requestRush.checked) {
      values.requestRush = true;
      var parsed = parsePinInput(view.pinInput.value);
      if (parsed.pin && view.pinConfirmation.checked) values.dropoffPin = Object.assign({}, parsed.pin, { confirmed: true });
    }
    return values;
  }

  function updatePin(reset) {
    if (!view) return;
    if (reset) { view.pinConfirmation.checked = false; pinLocationVersion++; }
    var parsed = parsePinInput(view.pinInput.value);
    view.pinConfirmation.disabled = submitting || !parsed.pin;
    view.pinStatus.textContent = parsed.error ? words[parsed.error] : parsed.pin ?
      (view.pinConfirmation.checked ? words.pinConfirmed : words.pinReady) + ' (' + parsed.pin.lat + ', ' + parsed.pin.lng + ')' : '';
    view.pinStatus.classList.toggle('c1-delivery__status--error', !!parsed.error);
    view.pinInput.setAttribute('aria-invalid', String(!!parsed.error));
    var selected = selectionPartial() || {};
    var search = [view.fields.streetAddress.value, selected.barangay && selected.barangay.name,
      selected.city && localCityName(selected.city.name, selected.province && selected.province.name),
      selected.province && selected.province.name, 'Philippines'].filter(Boolean).join(', ');
    view.pinSearch.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(search);
  }

  function updateRush(reset) {
    if (!view) return;
    var selected = selectionPartial(), allowed = !!(selected && selected.province && isRushProvince(selected.province.name));
    view.rush.hidden = !allowed;
    if (!allowed) view.requestRush.checked = false;
    view.pinSection.hidden = !allowed || !view.requestRush.checked;
    // Unchecked: one short line. Checked: the full rush rules.
    view.rushShort.hidden = view.requestRush.checked;
    view.rushHint.hidden = !view.requestRush.checked;
    updatePin(reset);
  }

  function locatePin() {
    if (submitting || !pending || !view.requestRush.checked || view.rush.hidden) return;
    var version = ++pinLocationVersion, lifecycle = lifecycleVersion;
    view.pinConfirmation.checked = false;
    if (!root.navigator || !root.navigator.geolocation) { view.pinStatus.textContent = words.pinLocationError; return; }
    view.pinStatus.textContent = words.pinLocating;
    root.navigator.geolocation.getCurrentPosition(function (position) {
      if (!pending || lifecycle !== lifecycleVersion || version !== pinLocationVersion || !view.requestRush.checked || view.rush.hidden) return;
      var pin = normalizeDropoffPin({ lat: position.coords.latitude, lng: position.coords.longitude });
      if (!pin) { view.pinStatus.textContent = words.pinLocationError; return; }
      view.pinInput.value = pin.lat.toFixed(7) + ', ' + pin.lng.toFixed(7);
      updatePin(true); scheduleQuote();
    }, function () {
      if (pending && lifecycle === lifecycleVersion && version === pinLocationVersion) view.pinStatus.textContent = words.pinLocationError;
    }, { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
  }

  function selectionPartial() {
    if (!directory) return null;
    var province = directory.provinces.find(function (item) { return item.id === view.fields.province.value; });
    var city = province && (province.cities || []).find(function (item) { return item.id === view.fields.city.value; });
    var barangay = city && (city.barangays || []).find(function (item) { return item.id === view.fields.barangay.value; });
    return { province: province, city: city, barangay: barangay };
  }

  function suggestZIP() {
    var choices = postalSuggestions(zipMap, selectionPartial());
    // Keep manually entered ZIPs. A changed locality replaces only our own prior
    // suggestion; an unknown or ambiguous locality clears that old suggestion.
    if (!view.fields.zip.value || postalWasSuggested) {
      view.fields.zip.value = choices.length === 1 ? choices[0] : '';
      postalWasSuggested = choices.length === 1;
      if (postalWasSuggested) showFieldError('zip', '');
    }
    view.zipHint.textContent = postalWasSuggested ? words.zipSuggested : words.zipHint;
  }

  function updateBarangays(initial) {
    if (!directory) return;
    var partial = selectionPartial();
    fillSelect(view.fields.barangay, partial.city && partial.city.barangays, words.chooseBarangay, 'barangay', initial && initial.barangay);
    ['province', 'city', 'barangay'].forEach(function (field) { view.fields[field].setCustomValidity(''); });
    suggestZIP();
    updateRush(true);
  }

  async function updateProvince(initial) {
    var version = ++locationVersion, lifecycle = lifecycleVersion;
    var id = view.fields.province.value;
    fillSelect(view.fields.city, [], words.chooseCity, 'city');
    fillSelect(view.fields.barangay, [], words.chooseBarangay, 'barangay');
    view.fields.province.setCustomValidity('');
    suggestZIP();
    view.retry.hidden = true;
    if (!id) { view.submit.disabled = !directory || cartReadyPending || cartReadyFailed; status(''); scheduleQuote(); return; }
    view.submit.disabled = true;
    status(words.loading);
    try {
      var province = await loadProvince(id);
      if (!pending || version !== locationVersion || lifecycle !== lifecycleVersion) return;
      fillSelect(view.fields.city, province.cities, words.chooseCity, 'city', initial && initial.city);
      updateBarangays(initial);
      view.submit.disabled = cartReadyPending || cartReadyFailed;
      status('');
      scheduleQuote();
    } catch (error) {
      if (!pending || version !== locationVersion || lifecycle !== lifecycleVersion) return;
      status(words.loadError, true);
      retryAction = function () { return updateProvince(initial); };
      view.retry.hidden = false;
    }
  }

  function savedCustomer() {
    var customer = config.customer || config.customerAddress || {};
    return {
      firstName: customer.firstName || customer.first_name || '',
      lastName: customer.lastName || customer.last_name || '',
      email: customer.email || '', phone: customer.phone || '',
      province: customer.provinceId || '', city: customer.cityId || '', barangay: customer.barangayId || '',
      streetAddress: customer.streetAddress || customer.address1 || '',
      landmark: customer.landmark || '', zip: customer.zip || ''
    };
  }

  function setBusy(busy) {
    var wasBusy = submitting;
    submitting = busy;
    view.form.setAttribute('aria-busy', String(busy));
    view.submit.setAttribute('aria-busy', String(busy));
    view.dialog.classList.toggle('c1-delivery-dialog--paying', busy || paymentHeld);
    view.dialog.setAttribute('aria-describedby', busy || paymentHeld ? 'c1-payment-loading-hint' : 'c1-delivery-introduction');
    view.paymentLoading.hidden = !busy && !paymentHeld;
    view.paymentSpinner.hidden = paymentHeld;
    view.paymentHeading.textContent = paymentHeld ? words.paymentCheckTitle : words.continuing;
    view.paymentHint.textContent = paymentHeld ? words.paymentCheckHint : words.openingPaymentHint;
    view.holdActions.hidden = !paymentHeld;
    view.submit.hidden = paymentHeld;
    if (busy && !wasBusy || paymentHeld) {
      var selectedRate = currentQuote && currentQuote.rates.find(function (rate) { return rate.id === view.rate.value; });
      view.paymentSummary.hidden = paymentHeld || !selectedRate;
      view.paymentCarrier.textContent = selectedRate ? selectedRate.title : '';
      view.paymentTotal.textContent = selectedRate ? money(selectedRate.totals.total) : '';
      view.paymentHeading.focus();
    }
    Object.keys(view.fields).forEach(function (key) {
      view.fields[key].disabled = busy || (!directory && ['province', 'city', 'barangay'].includes(key));
    });
    if (!busy && directory) {
      var selected = selectionPartial();
      view.fields.city.disabled = !selected.province || !Array.isArray(selected.province.cities);
      view.fields.barangay.disabled = !selected.city;
    }
    view.submit.disabled = busy || paymentHeld || !directory || quoting || quoteBindingPending || cartReadyPending || cartReadyFailed;
    view.rate.disabled = busy || paymentHeld || quoting || quoteBindingPending || cartReadyPending || cartReadyFailed;
    view.quoteRetry.disabled = busy || quoting || cartReadyPending || cartReadyFailed;
    view.submit.textContent = busy ? words.continuing : words.continue;
    if (busy) {
      var spinner = element('span', 'c1-delivery__button-spinner'); spinner.setAttribute('aria-hidden', 'true');
      view.submit.prepend(spinner);
    }
    view.requestRush.disabled = busy || !directory;
    view.pinInput.disabled = busy || !directory;
    view.pinLocate.disabled = busy || !directory;
    updatePin(false);
    view.close.disabled = busy;
    view.summaryEdit.disabled = busy;
    view.back.disabled = busy;
    if (!busy) clearPaymentFallback();
    if (!busy && wasBusy && !paymentHeld) view.submit.focus();
  }

  function clearPaymentFallback() {
    clearTimeout(paymentFallbackTimer); paymentFallbackTimer = null; verifiedPaymentURL = null;
    if (view) { view.paymentFallback.hidden = true; view.paymentLink.removeAttribute('href'); }
  }

  function schedulePaymentFallback(url) {
    clearPaymentFallback();
    verifiedPaymentURL = url;
    view.paymentLink.href = url;
    var lifecycle = lifecycleVersion;
    paymentFallbackTimer = setTimeout(function () {
      if (departing && lifecycle === lifecycleVersion && verifiedPaymentURL === url && view.dialog.open) view.paymentFallback.hidden = false;
    }, 12000);
  }

  function status(message, isError) {
    if (cartReadyPending) { message = words.cartSaving; isError = false; }
    else if (cartReadyFailed) { message = words.cartSaveError; isError = true; }
    view.status.textContent = message || '';
    view.status.classList.toggle('c1-delivery__status--error', !!isError);
  }

  // Small red text under phone, email or ZIP; a blank field waits for Continue.
  function showFieldError(key, code) {
    var error = view && view.fieldErrors[key];
    if (!error) return;
    error.textContent = code ? words[code] || words.required : '';
    error.hidden = !code;
    view.fields[key].setAttribute('aria-invalid', String(!!code));
  }

  function checkField(key) {
    if (!view || !pending || submitting) return;
    var value = view.fields[key].value;
    showFieldError(key, clean(value) ? fieldProblem(key, value) : '');
  }

  // Names what still blocks the total, in form order, using the field labels.
  function quotePromptFor(values) {
    if (!directory) return words.quotePrompt;
    var needed = ['firstName', 'lastName', 'phone', 'email', 'province', 'city', 'barangay', 'zip', 'streetAddress'].filter(function (key) {
      return !clean(values[key]) || (['phone', 'email', 'zip'].includes(key) && fieldProblem(key, values[key]));
    }).map(function (key) { return words[key]; });
    if (!needed.length) return words.quotePrompt;
    if (needed.length > 3) needed = needed.slice(0, 2).concat(words.quoteMore.replace('{count}', needed.length - 2));
    return words.quoteNeeds.replace('{fields}', needed.join(' · '));
  }

  // Buy now passes { text } so the buyer can check the item and spelling first.
  function showSummary(summary) {
    var text = summary && typeof summary.text === 'string' ? summary.text.replace(/\s+/g, ' ').trim() : '';
    if (text.length > 140) text = text.slice(0, 139) + '…';
    view.summaryText.textContent = text;
    view.summary.hidden = !text;
    view.summaryEdit.hidden = !text;
  }

  function paymentHoldError(error) {
    return error && ['CHECKOUT_HELD', 'CHECKOUT_REFRESHED', 'EXISTING_CHECKOUT_CHANGED', 'ADDRESS_CHANGED'].includes(error.code);
  }

  function showPaymentHold() {
    // A missing/changed earlier invoice is not proof that a payment was never
    // started. Keep its identity in the adapter and offer no replacement here.
    clearTimeout(quoteTimer); clearTimeout(quoteExpiryTimer); clearShopifyFallbackWait();
    quoteVersion++;
    quoting = false; scheduledQuoteKey = null; quoteKey = null; quoteBindingPending = true;
    quoteLoading(false);
    paymentHeld = true;
    view.shopifyFallback.hidden = true;
    view.paymentShopify.hidden = true;
    setBusy(false);
    view.paymentHeading.focus();
  }

  function backToDelivery() {
    currentQuote = null; currentPricingKey = null;
    view.shipping.hidden = true; view.priceDetails.textContent = ''; view.total.textContent = '—';
    view.quoteStatus.textContent = words.quotePrompt; view.quoteRetry.hidden = true;
    paymentHeld = false; setBusy(false);
    status(words.paymentCheckHint, true);
    view.heading.focus();
  }

  function finish(result, keepVisible) {
    if (!view || !pending) return;
    lifecycleVersion++;
    locationVersion++;
    quoteVersion++;
    clearTimeout(quoteTimer); clearTimeout(quoteExpiryTimer); clearShopifyFallbackWait();
    currentQuote = null; quoteKey = null; currentPricingKey = null; scheduledQuoteKey = null; quoteBindingPending = false; quoting = false;
    quoteLoading(false);
    cartReadyPending = false; cartReadyFailed = false;
    paymentHeld = false;
    if (!keepVisible) setBusy(false);
    savedValues = getValues();
    if (!keepVisible) clearPaymentFallback();
    if (view.dialog.open && !keepVisible) {
      if (typeof view.dialog.close === 'function') view.dialog.close();
      else view.dialog.removeAttribute('open');
    }
    var resolve = resolvePending;
    pending = null;
    resolvePending = null;
    if (!keepVisible && previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus();
    if (resolve) resolve(result);
  }

  function cancel() { if (!submitting) finish(null); }

  function safeCheckoutURL(value) {
    if (typeof value !== 'string' || !value.trim()) throw new Error('missing_checkout_url');
    var url = new URL(value, root.location.href);
    if (url.protocol !== 'https:' && !(url.origin === root.location.origin && url.protocol === 'http:')) throw new Error('invalid_checkout_url');
    return url.href;
  }

  // The checkout URL passed into open(). Shop checkout reads the same cart.
  function shopifyCheckoutURL() {
    try {
      var url = new URL(safeCheckoutURL(currentOptions && currentOptions.checkoutURL));
      var address = normalizeAddress(getValues(), directory);
      url.searchParams.set('checkout[email]', address.email);
      var shipping = {
        first_name: address.firstName, last_name: address.lastName, phone: address.phone,
        address1: address.streetAddress,
        address2: [address.barangay.name, address.landmark].filter(Boolean).join(', '),
        city: address.city.name, province: address.province.name, zip: address.zip, country: 'Philippines'
      };
      Object.keys(shipping).forEach(function (key) {
        url.searchParams.set('checkout[shipping_address][' + key + ']', shipping[key]);
      });
      return url.href;
    }
    catch (_) { return ''; }
  }

  function clearShopifyFallbackWait() {
    clearTimeout(shopifyFallbackTimer); shopifyFallbackTimer = null;
  }

  // A prepared invoice, an unresolved hold, or a preparing row saved before
  // /prepare returned must not be sent to a second checkout. Re-read storage;
  // the hold screen is not the only signal.
  function recoveryBlocksShopifyFallback() {
    if (!checkoutHandler || typeof checkoutHandler.shopifyFallbackSafe !== 'function') return false;
    try { return checkoutHandler.shopifyFallbackSafe() !== true; }
    catch (_) { return true; }
  }

  function showShopifyFallbackChoice() {
    if (!view || !pending || shopifyFallbackStarted || paymentHeld || recoveryBlocksShopifyFallback() || !shopifyCheckoutURL()) return;
    view.shopifyFallback.hidden = false;
    view.shopifyFallbackText.textContent = words.shopifyFallbackSlow;
    view.paymentShopify.hidden = false;
    view.paymentShopifyText.textContent = words.shopifyFallbackSlow;
    if (!submitting) status(words.shopifyFallbackSlow);
  }

  function armShopifyFallback(delay) {
    clearShopifyFallbackWait();
    if (!pending || shopifyFallbackStarted || paymentHeld || recoveryBlocksShopifyFallback() || !shopifyCheckoutURL()) return;
    var lifecycle = lifecycleVersion;
    shopifyFallbackTimer = setTimeout(function () {
      shopifyFallbackTimer = null;
      if (!pending || lifecycle !== lifecycleVersion || shopifyFallbackStarted || departing || paymentHeld || recoveryBlocksShopifyFallback()) return;
      showShopifyFallbackChoice();
    }, delay === undefined ? SHOPIFY_FALLBACK_WAIT_MS : delay);
  }

  // Leave the delivery dialog for the shop's own checkout. Does not clear the cart.
  function continueOnShopifyCheckout() {
    if (cartReadyPending || cartReadyFailed || paymentHeld || recoveryBlocksShopifyFallback()) return false;
    var url = shopifyCheckoutURL();
    if (!url || !view || (!pending && !shopifyFallbackStarted)) return false;
    var first = !shopifyFallbackStarted;
    shopifyFallbackStarted = true;
    clearShopifyFallbackWait();
    if (first && pending) {
      quoteVersion++;
      quoting = false; scheduledQuoteKey = null; quoteBindingPending = false;
      quoteLoading(false);
      clearTimeout(quoteTimer);
      var message = words.shopifyFallback;
      view.quoteRetry.hidden = true;
      view.quoteStatus.classList.remove('c1-delivery__status--error');
      view.quoteStatus.textContent = message;
      view.shopifyFallback.hidden = false;
      view.shopifyFallbackText.textContent = message;
      view.paymentShopify.hidden = false;
      view.paymentShopifyText.textContent = message;
      setBusy(false);
      status(message);
      departing = true;
    }
    try { root.location.assign(url); }
    catch (_) {
      if (first) { shopifyFallbackStarted = false; departing = false; }
      status(words.shopifyFallback, true);
      return false;
    }
    if (first && pending) finish({ checkoutUrl: url, shopifyFallback: true }, true);
    return true;
  }

  function addressKey(address) { return JSON.stringify(address); }

  // Display identity excludes only contact fields. It also works while a name,
  // email or mobile number is temporarily invalid, without sending fake values.
  // Payment still requires the separate full normalized addressKey below.
  function pricingKey(values) {
    var key = {};
    ['province', 'city', 'barangay'].forEach(function (field) { key[field] = selectedId(values, field) || ''; });
    ['streetAddress', 'landmark', 'zip'].forEach(function (field) { key[field] = clean(values[field]); });
    key.directoryVersion = values.directoryVersion || directory && directory.source && directory.source.version || '';
    key.requestRush = values.requestRush === true;
    var pin = key.requestRush && normalizeDropoffPin(values.dropoffPin);
    if (pin && values.dropoffPin.confirmed === true) key.dropoffPin = { lat: pin.lat, lng: pin.lng, confirmed: true };
    return JSON.stringify(key);
  }

  function money(amount) { return new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(amount / 100); }

  function showTotals() {
    if (!currentQuote) return;
    var rate = currentQuote.rates.find(function (item) { return item.id === view.rate.value; });
    if (!rate) return;
    var totals = rate.totals, rows = [words.items + ' ' + money(totals.items)];
    if (rate.breakdown) rows.push(words.fare + ' ' + money(rate.breakdown.fare), words.rushFee + ' ' + money(rate.breakdown.rushFee));
    if (totals.discount) rows.push(words.discount + ' −' + money(totals.discount));
    if (totals.tax) rows.push((totals.taxIncluded ? words.taxIncluded : words.tax) + ' ' + money(totals.tax));
    view.priceDetails.textContent = rows.join(' · ');
    view.total.textContent = money(totals.total);
  }

  // A placeholder holds the total's place while shipping is calculated. The
  // status line still carries the announcement; the total row is marked busy.
  function quoteLoading(active) {
    if (!view) return;
    view.priceRow.classList.toggle('c1-delivery__total--loading', active);
    view.priceRow.setAttribute('aria-busy', String(active));
    view.quoteStatus.classList.toggle('c1-delivery__quote-status--loading', active);
  }

  function scheduleQuote(delay) {
    if (!view || !pending || submitting || paymentHeld || cartReadyPending || cartReadyFailed) return;
    var values = getValues(), address, nextKey, nextPricingKey = pricingKey(values);
    try { if (directory) { address = normalizeAddress(values, directory); nextKey = addressKey(address); } } catch (_) {}
    // Input/change pairs and edits that normalize to the same address must not
    // hide a valid total or restart an identical in-flight request. An explicit
    // retry, server invalidation or expiry uses delay 0 and bypasses this guard.
    if (delay !== 0 && nextKey && ((currentQuote && quoteKey === nextKey &&
        (currentQuote.recoverable || Date.parse(currentQuote.expiresAt) > Date.now())) ||
        (quoting && scheduledQuoteKey === nextKey))) return;
    var preserveDisplay = delay !== 0 && currentQuote && currentPricingKey === nextPricingKey &&
      (currentQuote.recoverable === true || Date.parse(currentQuote.expiresAt) > Date.now()) && nextKey !== quoteKey;
    clearTimeout(quoteTimer);
    var version = ++quoteVersion;
    quoteKey = null; scheduledQuoteKey = null; quoting = false; quoteBindingPending = !!preserveDisplay;
    if (!preserveDisplay) {
      clearTimeout(quoteExpiryTimer);
      currentQuote = null; currentPricingKey = null;
      view.shipping.hidden = true;
      view.priceDetails.textContent = '';
      view.total.textContent = '—';
    }
    view.quoteRetry.hidden = true;
    if (!shopifyFallbackStarted) {
      clearShopifyFallbackWait();
      view.shopifyFallback.hidden = true;
      view.paymentShopify.hidden = true;
    }
    view.quoteStatus.textContent = preserveDisplay ? '' : address ? words.quotePrompt : quotePromptFor(values);
    view.quoteStatus.classList.remove('c1-delivery__status--error');
    quoteLoading(false);
    if (!directory || !checkoutHandler || typeof checkoutHandler.quote !== 'function') return;
    if (!address) {
      view.submit.disabled = quoteBindingPending || cartReadyPending || cartReadyFailed;
      view.rate.disabled = quoteBindingPending || cartReadyPending || cartReadyFailed;
      return;
    }
    scheduledQuoteKey = nextKey;
    quoting = true; view.submit.disabled = true;
    view.rate.disabled = true;
    armShopifyFallback(SHOPIFY_FALLBACK_WAIT_MS);
    if (!preserveDisplay) { view.quoteStatus.textContent = words.quoteLoading; quoteLoading(true); }
    quoteTimer = setTimeout(async function () {
      try {
        if (quoteRequest) { try { await quoteRequest; } catch (_) {} }
        if (version !== quoteVersion || !pending || cartReadyPending || cartReadyFailed || shopifyFallbackStarted) return;
        var request = checkoutHandler.quote(address);
        quoteRequest = request;
        var quote;
        try { quote = await request; } finally { if (quoteRequest === request) quoteRequest = null; }
        if (version !== quoteVersion || !pending || shopifyFallbackStarted) return;
        if (!quote || !quote.rates || !quote.rates.length || (!quote.recoverable && Date.parse(quote.expiresAt) <= Date.now())) throw new Error('invalid_quote');
        var standard = standardRate(quote);
        if (!standard) throw new Error('missing_standard_delivery');
        var previousRate = preserveDisplay ? view.rate.value : null;
        currentQuote = quote; quoteKey = addressKey(address); currentPricingKey = pricingKey(address); quoteBindingPending = false;
        view.rate.replaceChildren();
        quote.rates.forEach(function (rate) {
          var option = element('option', '', rate.title + ' · ' + money(rate.amount));
          option.value = rate.id; view.rate.append(option);
        });
        view.rate.value = previousRate && quote.rates.some(function (rate) { return rate.id === previousRate; }) ? previousRate : standard.id;
        view.shipping.hidden = false; view.quoteStatus.textContent = quote.recoverable === true ? words.resumingDelivery : '';
        showTotals();
        clearShopifyFallbackWait();
        view.shopifyFallback.hidden = true;
        view.paymentShopify.hidden = true;
        clearTimeout(quoteExpiryTimer);
        if (quote.expiresAt) quoteExpiryTimer = setTimeout(function () { scheduleQuote(0); }, Math.max(0, Date.parse(quote.expiresAt) - Date.now()));
      } catch (error) {
        if (version !== quoteVersion || !pending || shopifyFallbackStarted) return;
        clearShopifyFallbackWait();
        if (paymentHoldError(error)) { showPaymentHold(); return; }
        if (error && error.fallbackToShopify === true && continueOnShopifyCheckout()) return;
        view.quoteStatus.textContent = words.quoteError;
        view.quoteStatus.classList.add('c1-delivery__status--error');
        view.quoteRetry.hidden = false;
      } finally {
        if (version === quoteVersion && pending) {
          quoting = false; scheduledQuoteKey = null; quoteLoading(false);
          view.submit.disabled = paymentHeld || quoteBindingPending || cartReadyPending || cartReadyFailed;
          view.rate.disabled = paymentHeld || quoteBindingPending || cartReadyPending || cartReadyFailed;
        }
      }
    }, delay === undefined ? 450 : delay);
  }

  async function submit(event) {
    event.preventDefault();
    if (submitting || paymentHeld || quoting || quoteBindingPending || !directory || cartReadyPending || cartReadyFailed) return;
    var values = getValues(), address;
    Object.keys(view.fields).forEach(function (key) { view.fields[key].setCustomValidity(''); });
    try { address = normalizeAddress(values, directory); }
    catch (error) {
      if (error.field && view.fields[error.field]) {
        if (error.field === 'landmark') view.landmark.open = true;
        view.fields[error.field].setCustomValidity(words[error.code] || words.required);
        showFieldError(error.field, error.code);
      }
    }
    if (!view.form.reportValidity() || !address) return;
    var options = Object.assign({}, currentOptions);
    delete options.cartReady; delete options.summary;
    delete options.confirmedUnpaidRestart; delete options.restartToken;
    if (checkoutHandler && typeof checkoutHandler.quote === 'function') {
      if (!currentQuote || quoteKey !== addressKey(address) || (currentQuote.expiresAt && Date.parse(currentQuote.expiresAt) <= Date.now())) {
        scheduleQuote(0); return;
      }
      options.quoteId = currentQuote.quoteId;
      options.selectedRateId = view.rate.value;
    }
    savedValues = values;
    setBusy(true);
    status(words.continuing);
    armShopifyFallback(SHOPIFY_FALLBACK_WAIT_MS);
    try {
      if (typeof checkoutHandler !== 'function') {
        if (continueOnShopifyCheckout()) return;
        throw new Error('missing_checkout_handler');
      }
      var result = await checkoutHandler(address, options);
      if (shopifyFallbackStarted || !pending) return;
      clearShopifyFallbackWait();
      var url = safeCheckoutURL(typeof result === 'string' ? result : result && result.checkoutUrl);
      root.location.assign(url);
      departing = true;
      finish({ checkoutUrl: url, address: address }, true);
      schedulePaymentFallback(url);
    } catch (error) {
      if (shopifyFallbackStarted || !pending) return;
      clearShopifyFallbackWait();
      var code = error && error.code;
      if (paymentHoldError(error)) { showPaymentHold(); return; }
      if (error && error.fallbackToShopify === true && continueOnShopifyCheckout()) return;
      status(words.checkoutError, true);
      setBusy(false);
      if (['QUOTE_EXPIRED', 'QUOTE_CHANGED', 'CART_CHANGED', 'CHECKOUT_UNAVAILABLE', 'CHECKOUT_NOT_STARTED'].includes(code)) scheduleQuote(0);
    }
  }

  function mount(container) {
    if (view) return view.dialog;
    readConfig();
    if (!root.document) throw new Error('delivery_requires_browser');
    if (typeof container === 'string') container = root.document.querySelector(container);
    container = container || root.document.getElementById('c1-delivery-root') || root.document.body;
    var dialog = element('dialog', 'c1-delivery-dialog');
    dialog.id = 'c1-delivery-dialog';
    dialog.setAttribute('aria-labelledby', 'c1-delivery-title');
    dialog.setAttribute('aria-describedby', 'c1-delivery-introduction');
    dialog.setAttribute('aria-modal', 'true');
    var header = element('div', 'c1-delivery__header');
    var heading = element('h2', 'c1-delivery__title', words.title);
    heading.id = 'c1-delivery-title';
    heading.tabIndex = -1;
    var close = element('button', 'c1-delivery__close', words.close);
    close.type = 'button';
    close.addEventListener('click', cancel);
    header.append(heading, close);
    var summary = element('div', 'c1-delivery__summary'); summary.hidden = true;
    var summaryText = element('p', 'c1-delivery__summary-text'); summaryText.id = 'c1-delivery-summary';
    var summaryEdit = element('button', 'c1-delivery__back c1-delivery__summary-edit', words.editSummary);
    summaryEdit.type = 'button'; summaryEdit.hidden = true; summaryEdit.setAttribute('aria-describedby', summaryText.id);
    summaryEdit.addEventListener('click', cancel);
    summary.append(summaryText, summaryEdit);
    var introduction = element('p', 'c1-delivery__introduction', words.introduction);
    introduction.id = 'c1-delivery-introduction';
    var liveStatus = element('p', 'c1-delivery__status');
    liveStatus.setAttribute('role', 'status');
    liveStatus.setAttribute('aria-live', 'polite');
    var retry = element('button', 'c1-delivery__retry', words.retry);
    retry.type = 'button';
    retry.hidden = true;
    retry.addEventListener('click', function () { if (retryAction) retryAction(); });
    var form = element('form', 'c1-delivery__form');
    form.noValidate = true;
    form.autocomplete = 'on';
    var fieldsWrapper = element('div', 'c1-delivery__fields');
    var fields = {}, fieldErrors = {};
    var fieldSpecs = [
      { key: 'firstName', autocomplete: 'given-name', max: 100 },
      { key: 'lastName', autocomplete: 'family-name', max: 100 },
      { key: 'phone', type: 'tel', autocomplete: 'tel', max: 24, hint: 'phoneHint', inputmode: 'tel', full: true, check: true },
      { key: 'email', type: 'email', autocomplete: 'email', max: 254, hint: 'emailHint', shownHint: true, full: true, check: true },
      { key: 'province', select: true, autocomplete: 'address-level1' },
      { key: 'city', select: true, autocomplete: 'address-level2' },
      { key: 'barangay', select: true, autocomplete: 'address-level3' },
      { key: 'zip', autocomplete: 'postal-code', max: 4, inputmode: 'numeric', pattern: '[0-9]{4}', hint: 'zipHint', check: true },
      { key: 'streetAddress', autocomplete: 'address-line1', max: 200, full: true, placeholder: 'streetPlaceholder' },
      { key: 'landmark', autocomplete: 'off', max: 100, full: true, optional: true, placeholder: 'landmarkPlaceholder' }
    ];
    var zipHint, landmark = element('details', 'c1-delivery__landmark');
    landmark.append(element('summary', '', words.addLandmark));
    fieldSpecs.forEach(function (spec) {
      var wrapper = element('div', 'c1-delivery__field' + (spec.full ? ' c1-delivery__field--full' : ''));
      var label = element('label', '', words[spec.key]);
      var control = element(spec.select ? 'select' : 'input');
      control.id = 'c1-delivery-' + spec.key;
      control.name = spec.key;
      label.htmlFor = control.id;
      control.required = !spec.optional;
      control.autocomplete = spec.autocomplete;
      if (!spec.select) {
        control.type = spec.type || 'text';
        if (spec.max) control.maxLength = spec.max;
        if (spec.pattern) control.pattern = spec.pattern;
        if (spec.inputmode) control.inputMode = spec.inputmode;
        if (spec.placeholder) control.placeholder = words[spec.placeholder];
      }
      control.addEventListener('input', function () {
        control.setCustomValidity('');
        showFieldError(spec.key, '');
        if (spec.key === 'zip') {
          postalWasSuggested = false;
          view.zipHint.textContent = words.zipHint;
        }
        if (['province', 'city', 'barangay', 'streetAddress', 'zip'].includes(spec.key)) updateRush(true);
        scheduleQuote();
      });
      wrapper.append(label, control);
      if (spec.hint) {
        var hint = element('p', 'c1-delivery__hint' + (spec.shownHint ? '' : ' c1-delivery__hint--compact'), words[spec.hint]);
        hint.id = control.id + '-hint';
        control.setAttribute('aria-describedby', hint.id);
        wrapper.append(hint);
        if (spec.key === 'zip') zipHint = hint;
      }
      if (spec.check) {
        var fieldError = element('p', 'c1-delivery__field-error');
        fieldError.id = control.id + '-error'; fieldError.hidden = true;
        control.setAttribute('aria-describedby', (spec.hint ? control.id + '-hint ' : '') + fieldError.id);
        control.addEventListener('blur', function () { checkField(spec.key); });
        wrapper.append(fieldError);
        fieldErrors[spec.key] = fieldError;
      }
      fields[spec.key] = control;
      if (spec.key === 'landmark') landmark.append(wrapper);
      else fieldsWrapper.append(wrapper);
    });
    fields.province.addEventListener('change', function () { updateRush(true); updateProvince(); });
    fields.city.addEventListener('change', function () { updateBarangays(); scheduleQuote(); });
    fields.barangay.addEventListener('change', function () { suggestZIP(); updateRush(true); scheduleQuote(); });
    var rush = element('div', 'c1-delivery__rush'); rush.hidden = true;
    var rushLabel = element('label', 'c1-delivery__unpaid-label'), requestRush = element('input');
    requestRush.type = 'checkbox'; requestRush.id = 'c1-delivery-request-rush';
    rushLabel.append(requestRush, element('span', '', words.requestRush));
    var rushShort = element('p', 'c1-delivery__hint', words.rushShort);
    var rushHint = element('p', 'c1-delivery__hint', words.rushHint); rushHint.id = 'c1-delivery-rush-hint'; rushHint.hidden = true;
    requestRush.setAttribute('aria-describedby', rushHint.id);
    var pinSection = element('div', 'c1-delivery__pin'); pinSection.hidden = true;
    var pinField = element('div', 'c1-delivery__field c1-delivery__field--full');
    var pinLabel = element('label', '', words.pinLabel), pinInput = element('input');
    pinInput.type = 'text'; pinInput.id = 'c1-delivery-pin'; pinInput.maxLength = 4096;
    pinInput.autocomplete = 'off'; pinInput.spellcheck = false; pinInput.placeholder = words.pinPlaceholder;
    pinLabel.htmlFor = pinInput.id;
    var pinHint = element('p', 'c1-delivery__hint', words.pinHint); pinHint.id = pinInput.id + '-hint';
    var pinStatus = element('p', 'c1-delivery__status'); pinStatus.id = pinInput.id + '-status';
    pinStatus.setAttribute('role', 'status'); pinStatus.setAttribute('aria-live', 'polite');
    pinInput.setAttribute('aria-describedby', pinHint.id + ' ' + pinStatus.id);
    var pinSearch = element('a', 'c1-delivery__pin-search', words.pinSearch);
    pinSearch.target = '_blank'; pinSearch.rel = 'noopener noreferrer'; pinSearch.referrerPolicy = 'no-referrer';
    var pinLocate = element('button', 'c1-delivery__back', words.pinLocation); pinLocate.type = 'button';
    var pinConfirmLabel = element('label', 'c1-delivery__unpaid-label'), pinConfirmation = element('input');
    pinConfirmation.type = 'checkbox'; pinConfirmation.id = 'c1-delivery-pin-confirmation'; pinConfirmation.disabled = true;
    pinConfirmLabel.append(pinConfirmation, element('span', '', words.pinConfirm));
    pinField.append(pinLabel, pinInput, pinHint);
    pinSection.append(pinField, pinSearch, pinLocate, pinStatus, pinConfirmLabel);
    rush.append(rushLabel, rushShort, rushHint, pinSection);
    requestRush.addEventListener('change', function () { updateRush(true); scheduleQuote(); });
    pinInput.addEventListener('input', function () { updatePin(true); scheduleQuote(); });
    pinConfirmation.addEventListener('change', function () { updatePin(false); scheduleQuote(); });
    pinLocate.addEventListener('click', locatePin);
    var country = element('p', 'c1-delivery__country', words.country);
    var countryValue = element('input');
    countryValue.type = 'hidden';
    countryValue.name = 'country';
    countryValue.value = 'Philippines';
    countryValue.autocomplete = 'country-name';
    var body = element('div', 'c1-delivery__body');
    // The item summary scrolls with the form so it never shrinks the fields while typing.
    body.append(summary, fieldsWrapper, landmark, rush, country, countryValue);
    var actions = element('div', 'c1-delivery__actions');
    var paymentLoading = element('div', 'c1-delivery__payment-loading'); paymentLoading.hidden = true;
    paymentLoading.setAttribute('role', 'status'); paymentLoading.setAttribute('aria-live', 'polite'); paymentLoading.setAttribute('aria-atomic', 'true');
    var paymentSpinner = element('span', 'c1-delivery__payment-spinner'); paymentSpinner.setAttribute('aria-hidden', 'true');
    var paymentHeading = element('h3', 'c1-delivery__payment-heading', words.continuing); paymentHeading.tabIndex = -1;
    var paymentHint = element('p', 'c1-delivery__payment-hint', words.openingPaymentHint); paymentHint.id = 'c1-payment-loading-hint';
    var paymentSummary = element('div', 'c1-delivery__payment-summary'); paymentSummary.hidden = true;
    var paymentCarrier = element('span', 'c1-delivery__payment-carrier'), paymentTotal = element('strong', 'c1-delivery__payment-total');
    var paymentAmount = element('span', 'c1-delivery__payment-amount'); paymentAmount.append(element('span', '', words.total), paymentTotal);
    paymentSummary.append(paymentCarrier, paymentAmount);
    var paymentFallback = element('div', 'c1-delivery__payment-fallback'); paymentFallback.hidden = true;
    var paymentLink = element('a', 'c1-delivery__payment-link', words.openPaymentPage);
    paymentFallback.append(element('p', '', words.paymentFallbackHint), paymentLink);
    var holdActions = element('div', 'c1-delivery__hold-actions'); holdActions.hidden = true;
    var holdBack = element('button', 'c1-delivery__payment-link c1-delivery__hold-back', words.backToDelivery); holdBack.type = 'button';
    holdBack.addEventListener('click', backToDelivery);
    var holdContact = element('a', 'c1-delivery__payment-link c1-delivery__hold-contact', words.contactUs);
    holdContact.href = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root || '/').replace(/\/?$/, '/') + 'pages/contact';
    holdContact.target = '_blank'; holdContact.rel = 'noopener';
    holdActions.append(holdBack, holdContact);
    var paymentShopify = element('div', 'c1-delivery__payment-shopify'); paymentShopify.hidden = true;
    var paymentShopifyText = element('p', '', words.shopifyFallbackSlow);
    var paymentShopifyButton = element('button', 'c1-delivery__payment-link', words.shopifyFallbackAction);
    paymentShopifyButton.type = 'button';
    paymentShopifyButton.addEventListener('click', continueOnShopifyCheckout);
    paymentShopify.append(paymentShopifyText, paymentShopifyButton);
    paymentLoading.append(paymentSpinner, paymentHeading, paymentHint, paymentSummary, paymentFallback, paymentShopify, holdActions);
    var shipping = element('div', 'c1-delivery__shipping'); shipping.hidden = true;
    var rateLabel = element('label', '', words.shipping), rate = element('select');
    rate.id = 'c1-delivery-rate'; rateLabel.htmlFor = rate.id;
    rate.addEventListener('change', function () { showTotals(); setBusy(false); }); shipping.append(rateLabel, rate);
    var priceDetails = element('p', 'c1-delivery__price-details');
    var priceRow = element('div', 'c1-delivery__total');
    var total = element('strong', '', '—');
    priceRow.append(element('span', '', words.total), total);
    priceRow.setAttribute('aria-live', 'polite'); priceRow.setAttribute('aria-atomic', 'true');
    var quoteStatus = element('p', 'c1-delivery__quote-status', words.quotePrompt);
    quoteStatus.setAttribute('role', 'status');
    var quoteRetry = element('button', 'c1-delivery__quote-retry', words.retry); quoteRetry.type = 'button'; quoteRetry.hidden = true;
    quoteRetry.addEventListener('click', function () { scheduleQuote(0); });
    var shopifyFallback = element('div', 'c1-delivery__shopify-fallback'); shopifyFallback.hidden = true;
    var shopifyFallbackText = element('p', '', words.shopifyFallbackSlow);
    var shopifyFallbackButton = element('button', 'c1-delivery__payment-link', words.shopifyFallbackAction);
    shopifyFallbackButton.type = 'button';
    shopifyFallbackButton.addEventListener('click', continueOnShopifyCheckout);
    shopifyFallback.append(shopifyFallbackText, shopifyFallbackButton);
    var submitButton = element('button', 'c1-delivery__continue', words.continue);
    submitButton.type = 'submit';
    var back = element('button', 'c1-delivery__back', words.back);
    back.type = 'button'; back.hidden = true;
    back.addEventListener('click', cancel);
    // Under Continue: a muted next-step line and a quiet Messenger link. Both hide while paying (CSS).
    var paymentNext = element('p', 'c1-delivery__hint c1-delivery__next', words.paymentNext);
    var help = element('a', 'c1-delivery__back c1-delivery__help', words.messengerHelp);
    help.href = messengerURL; help.target = '_blank'; help.rel = 'noopener noreferrer';
    actions.append(shipping, priceDetails, priceRow, quoteStatus, quoteRetry, shopifyFallback, submitButton, paymentNext, help, back);
    form.append(body, actions);
    form.addEventListener('submit', submit);
    // Keep the loading announcement outside the form's aria-busy subtree.
    dialog.append(header, introduction, liveStatus, retry, paymentLoading, form);
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); cancel(); });
    dialog.addEventListener('close', function () { if (!submitting) finish(null); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); cancel(); }
      if (event.key !== 'Tab') return;
      if (paymentHeld) {
        event.preventDefault();
        var onBack = root.document.activeElement === view.holdBack;
        var onContact = root.document.activeElement === view.holdContact;
        (event.shiftKey ? onContact ? view.holdBack : view.holdContact : onBack ? view.holdContact : view.holdBack).focus();
        return;
      }
      if (departing && !view.paymentFallback.hidden && verifiedPaymentURL) {
        event.preventDefault(); view.paymentLink.focus(); return;
      }
      var focusable = Array.from(dialog.querySelectorAll('button:not([disabled]):not([hidden]), input:not([disabled]):not([type="hidden"]), select:not([disabled])'));
      // The Messenger link is the last control under Continue; keep it in the Tab loop while it is shown.
      if (help.getClientRects().length) focusable.push(help);
      if (!focusable.length) { event.preventDefault(); heading.focus(); return; }
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && (root.document.activeElement === first || root.document.activeElement === heading)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && root.document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    container.append(dialog);
    view = { dialog: dialog, heading: heading, form: form, fields: fields, close: close, back: back,
      status: liveStatus, retry: retry, submit: submitButton, zipHint: zipHint, landmark: landmark,
      shipping: shipping, rate: rate, total: total, priceRow: priceRow, priceDetails: priceDetails, quoteStatus: quoteStatus, quoteRetry: quoteRetry,
      shopifyFallback: shopifyFallback, shopifyFallbackText: shopifyFallbackText, paymentShopify: paymentShopify, paymentShopifyText: paymentShopifyText,
      fieldErrors: fieldErrors, summary: summary, summaryText: summaryText, summaryEdit: summaryEdit,
      rush: rush, rushShort: rushShort, rushHint: rushHint, requestRush: requestRush, pinSection: pinSection, pinInput: pinInput, pinConfirmation: pinConfirmation,
      pinStatus: pinStatus, pinSearch: pinSearch, pinLocate: pinLocate,
      paymentLoading: paymentLoading, paymentHeading: paymentHeading, paymentHint: paymentHint, paymentSpinner: paymentSpinner,
      paymentSummary: paymentSummary, paymentCarrier: paymentCarrier, paymentTotal: paymentTotal,
      paymentFallback: paymentFallback, paymentLink: paymentLink, holdActions: holdActions, holdBack: holdBack, holdContact: holdContact };
    setBusy(false);
    if (typeof root.addEventListener === 'function') root.addEventListener('pageshow', function () {
      if (!departing) return;
      departing = false;
      shopifyFallbackStarted = false;
      setBusy(false);
      if (view.dialog.open) {
        if (typeof view.dialog.close === 'function') view.dialog.close();
        else view.dialog.removeAttribute('open');
      }
      if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus();
    });
    return dialog;
  }

  async function prepare(resetFields) {
    var lifecycle = lifecycleVersion;
    var initial = resetFields ? savedValues || savedCustomer() : getValues();
    if (resetFields) {
      Object.keys(view.fields).forEach(function (key) {
        if (!['province', 'city', 'barangay'].includes(key)) view.fields[key].value = initial[key] || '';
      });
      view.landmark.open = !!initial.landmark;
      Object.keys(view.fieldErrors).forEach(function (key) { showFieldError(key, ''); });
      view.requestRush.checked = false;
      view.pinInput.value = '';
      view.pinConfirmation.checked = false;
    }
    setBusy(false);
    view.retry.hidden = true;
    status(words.loading);
    view.submit.disabled = true;
    try {
      await loadData();
      if (!pending || lifecycle !== lifecycleVersion) return;
      fillSelect(view.fields.province, directory.provinces, words.chooseProvince, 'province', initial.province);
      setBusy(false);
      await updateProvince(initial);
    } catch (error) {
      if (!pending || lifecycle !== lifecycleVersion) return;
      status(words.loadError, true);
      retryAction = prepare;
      view.retry.hidden = false;
    }
  }

  function open(options) {
    if (departing) return Promise.resolve(null);
    if (pending) return pending;
    mount();
    paymentHeld = false;
    shopifyFallbackStarted = false;
    clearShopifyFallbackWait();
    view.shopifyFallback.hidden = true;
    view.paymentShopify.hidden = true;
    clearPaymentFallback();
    lifecycleVersion++;
    currentOptions = options || {};
    showSummary(currentOptions.summary);
    cartReadyPending = !!(currentOptions.cartReady && typeof currentOptions.cartReady.then === 'function');
    cartReadyFailed = false;
    // A pending add must never display the previous modal's shipping choice.
    view.shipping.hidden = true; view.priceDetails.textContent = ''; view.total.textContent = '—';
    view.quoteStatus.textContent = words.quotePrompt; view.quoteRetry.hidden = true; quoteLoading(false);
    previousFocus = root.document.activeElement;
    pending = new Promise(function (resolve) { resolvePending = resolve; });
    if (typeof view.dialog.showModal === 'function') view.dialog.showModal();
    else view.dialog.setAttribute('open', '');
    view.heading.focus();
    // A re-opened sheet keeps its old scroll position; start at the top so the item summary is seen.
    if (!view.summary.hidden) view.summary.parentNode.scrollTop = 0;
    prepare(true);
    var lifecycle = lifecycleVersion;
    function ready() {
      if (!pending || lifecycle !== lifecycleVersion) return;
      cartReadyPending = false;
      status(view.retry.hidden ? '' : words.loadError, !view.retry.hidden); setBusy(false);
      // Cart mutation and note saves are confirmed before even session warm-up.
      if (checkoutHandler && typeof checkoutHandler.warmup === 'function') {
        try { Promise.resolve(checkoutHandler.warmup()).catch(function () {}); } catch (_) {}
      }
      scheduleQuote(0);
    }
    if (cartReadyPending) Promise.resolve(currentOptions.cartReady).then(ready, function () {
      if (!pending || lifecycle !== lifecycleVersion) return;
      cartReadyPending = false; cartReadyFailed = true;
      status(''); setBusy(false);
    });
    else ready();
    return pending;
  }

  function setCheckoutHandler(handler) {
    if (typeof handler !== 'function') throw new TypeError('Checkout handler must be a function');
    checkoutHandler = handler;
  }

  return { open: open, mount: mount, preload: loadData, setCheckoutHandler: setCheckoutHandler, cartReadyVersion: 1,
    normalizePhone: normalizePhone, validateSelection: validateSelection,
    normalizeAddress: normalizeAddress, postalSuggestions: postalSuggestions,
    parsePinInput: parsePinInput, normalizeDropoffPin: normalizeDropoffPin,
    isRushProvince: isRushProvince, standardRate: standardRate };
});
